// extracted by mini-css-extract-plugin
export default {"zoomModal":"I4-z"};